import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CropStages, FylloHeader } from "react-library";
import { TBackEvent } from "../../types";
import { Routes } from "../../routes";
import { CropSownObj, CropStagesObject } from "stencil-library";
import { t } from "../../services/locale.service";

export type CropStageDetails = {
  cropStagesArr: Array<CropStagesObject>,
  crop: string,
  activeStgIndx: number,
  isSeasonEnded: boolean,
  cropSownDetails: CropSownObj
}

const CropStageDetailContainer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { plotId } = useParams();

  const cropStageDetails = location.state.cropStageDetails as CropStageDetails;
  const headerTitle = t("Crop_Stage_Details");

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);

    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  const handleBack = (e: Event) => {
    const event = e as TBackEvent;
    const eventKey = event.detail;
    if (eventKey === headerTitle) {
      navigate(Routes.plot.replace(":plotId", plotId!));
    }
  };

  return (
    <div>
      <FylloHeader headerTitle={headerTitle} hasBackIcon />

      <CropStages
        {...cropStageDetails}
      />
    </div>
  );
};

export default CropStageDetailContainer;